/* global API */

const LIST_CLASS = '.js-media-list';
const SELECTION_BAR_CLASS = '.js-selection-bar';
const SELECTION_COUNT_CLASS = '.js-selection-bar-count';
const SELECTION_DELETE_CLASS = '.js-selection-delete';
const SELECTION_SELECT_CLASS = '.js-selection-select';
const SELECTION_FOLDERS_CLASS = '.js-selection-folders';
const SELECTION_ACTION_CLASS = '.js-selection-actions';

const Selection = {
  create(node, options) {
    this.options = options;
    this.$list = $(node).find(LIST_CLASS);
    this.$selectionBar = $(node).find(SELECTION_BAR_CLASS);
    this.$lastMediaItem = null;

    // Listen for changes on the checkboxes
    this.$list.on('change', 'input[type="checkbox"]', (e) => {
      const $el = $(e.currentTarget);
      const $mediaItem = $el.parents('.js-media-item');
      this.$lastMediaItem = $mediaItem;
      this.handleCheck();
    });

    // Handle clicks on the items to allow shift + click behaviour
    this.$list.on('click', '.js-media-item', (e) => {
      if (e.shiftKey) {
        e.preventDefault();
        const $mediaItem = $(e.currentTarget);

        if (this.$lastMediaItem) {
          this.selectBetween($mediaItem, this.$lastMediaItem);
        }

        this.$lastMediaItem = $mediaItem;

        $mediaItem.find('input[type="checkbox"]').prop('checked', true).trigger('change');
      }
    });

    // Handle clicks on the select none/all button
    this.$selectionBar.on('click', SELECTION_SELECT_CLASS, () => {
      const checked = this.getCheckedCount();

      if (checked > 0) {
        this.getChecked().prop('checked', false);
      } else {
        this.getAllChecks().prop('checked', true);
      }

      this.handleCheck();
    });

    // Listen for changes on the delete items button
    this.$selectionBar.on('click', SELECTION_DELETE_CLASS, () => {
      if (confirm('Weet je het zeker?')) { // eslint-disable-line
        this.deleteItems(this.getCheckedIds())
          .then(() => {
            this.refreshList();
          });
      }
    });

    // Listen for changes on the folders dropdown
    this.$selectionBar.on('click', `${SELECTION_FOLDERS_CLASS} a`, (e) => {
      e.preventDefault();
      const $el = $(e.currentTarget);
      const folderId = $el.data('folder-id');

      this.moveItems(this.getCheckedIds(), folderId)
        .then(() => {
          this.refreshList();
        });
    });

    // Listen for changes to the media list
    window.pubsub.subscribe('media:loaded', () => {
      this.handleCheck();
    });
  },

  /**
   * Ask for a refresh on the media list
   * @return {void}
   */
  refreshList() {
    window.pubsub.publish('media:filter');
  },

  /**
   * Get all media item checkboxes
   * @return {Object}
   */
  getAllChecks() {
    return this.$list.find('input');
  },

  /**
   * Get all checked input elements
   * @return {Object}
   */
  getChecked() {
    return this.$list.find('input:checked');
  },

  /**
   * Get a count of the selected items
   * @return {Number}
   */
  getCheckedCount() {
    return this.getChecked().length;
  },

  /**
   * Get the id's of all checked media items
   * @return {Array}
   */
  getCheckedIds() {
    return this.getChecked().toArray().map((check) => check.value);
  },

  /**
   * Handle changes to checkbox on the media items
   * @return {void}
   */
  handleCheck() {
    const checked = this.getCheckedCount();

    // Set label for count
    const label = checked === 1 ? 'bestand geselecteerd' : 'bestanden geselecteerd';
    $(SELECTION_COUNT_CLASS).text(`${checked} ${label}`);

    // Set label on the select none/all button
    const selectionLabel = checked > 0 ? 'Deselecteer alles' : 'Selecteer alles';
    $(SELECTION_SELECT_CLASS).text(selectionLabel);

    // Hide or show the available actions
    $(SELECTION_ACTION_CLASS).toggle(checked > 0);
  },

  /**
   * Move items with id's to folder
   * @param {Array} ids List of id's to move
   * @param {Number} folderId Id of the folder to move the media into
   * @return {Promise}
   */
  moveItems(ids, folderId) {
    return window.axios.post(API.media.moveUrl, {
      items: ids,
      folder: folderId,
    })
      .catch((err) => {
        console.error(err); // eslint-disable-line
      });
  },

  /**
   * Send deletion call to the API
   * @param {Array} ids
   * @return {Promise}
   */
  deleteItems(ids) {
    return window.axios.post(API.media.deleteUrl, {
      items: ids,
    })
      .catch((err) => {
        console.error(err); // eslint-disable-line
      });
  },

  /**
   * Select all elements between these two elements
   * @param {Object} $itemOne
   * @param {Object} $itemTwo
   * @return {void}
   */
  selectBetween($itemOne, $itemTwo) {
    const $colOne = $itemOne.parents('.js-media-col');
    const $colTwo = $itemTwo.parents('.js-media-col');

    const colOneIndex = $colOne.index();
    const colTwoIndex = $colTwo.index();

    let $colsBetween;

    if (colOneIndex > colTwoIndex) {
      $colsBetween = $colOne.prevUntil($colTwo);
    } else {
      $colsBetween = $colOne.nextUntil($colTwo);
    }

    $colsBetween.toArray().forEach((col) => {
      const $col = $(col);
      const $checkbox = $col.find('input[type="checkbox"]');
      const isChecked = $checkbox[0].checked;
      $checkbox.prop('checked', !isChecked);
    });
  },
};

export default Selection;
